import React, { useEffect, useState } from 'react';
import { translate } from '../../utils/language';
import { CloseButton } from '../../assets/svgs';
import MyInput from '../../components/ui/MyInput';
import PrimaryButton from '../../components/ui/PrimaryButton';
import CreateAction from '../../components/operational/createAction';
import MobligoLogo from '../../assets/img/mobligo_new.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { license } from '../../data/license';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { toastError } from '../../components/ui/System/MobligoToast';
import systemSlice from '../../redux/systemSlice';
import ThemesIntegrationModal from './ThemesIntegrationModal.tsx'
import QRCode from 'react-qr-code';
import { QrCodeIcon } from '@heroicons/react/24/outline';
import ThemeLicenseModal from '../ThemeScreen/DnDNew/components/Modals/ThemeLicenseModal';
function ThemesModal({ isOpen, setIsOpen }) {
  const [error, setError] = useState(false);
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false)
  const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false)

  const [themeName, setThemeName] = useState('');
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [themes, setTheme] = useState([]);
  const app = useSelector((state) => state.myAppsSlice?.localReduxData.app);
  const isDemo = app?.isDemo
  const activeLicense = useSelector((state) => state.myUserSlice?.license);
  const dispatch = useDispatch()
  useEffect(() => {
    getDefualtThemes();
  }, []);
  const getDefualtThemes = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/theme`,
      showPreLoader: true,
      isFileUploading: false,
    });
    if (!response.error) {
      const initialThemes = response?.result?.resultData;
      initialThemes.sort((a, b) => (a.name > b.name ? 1 : -1));
      setTheme(initialThemes);
      // setSelectedTheme(initialThemes[0]);
    }
  };

  const handleClickedSaveButton = async () => {
    const isActive = license[selectedTheme?.minLicenseType]?.order <= activeLicense?.order
    if (themeName == '' || selectedTheme == null) {
      dispatch(systemSlice.actions.setToastError({ summary: "Lütfen bir tema seçiniz." }))
      setError(true);
      return;
    }
    if (!isActive) {
      return setIsLicenseModalOpen(true)
    }


    setError(false);
    const response = await CreateAction({
      method: 'post',
      path: `/createMainTheme`,
      showPreLoader: true,
      isFileUploading: false,
      data: {
        themeId: selectedTheme.id,
        newTheme: {
          name: themeName,
        },
      },
    });
    setIsOpen(false);
    // setSelectedTheme(selectedTheme[0]);
    setThemeName('');
  };

  return (
    <>
      {isOpen && (
        <div className="appear fixed inset-0 overflow-y-auto flex flex-col p-5 items-center overflow-hidden top-0 left-0 z-[50] ">
          <div className="shadow"></div>

          <div
            className="flex flex-col bg-white w-[90%] xl:w-[1200px] min-h-[90dvh] z-[500]  overflow-hidden	"
            style={{ borderRadius: '10px' }}
          >
            <div className="flex flex-row w-full z-[500] overflow-hidden ">
              <div
                className="w-auto bg-[#F6F6F6] flex flex-col"
                style={{ padding: '25px 20px', gap: '20px', borderTopLeftRadius: '10px' }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div className="text-[#5E5873] text-center">Native Premium</div>
                  {themes &&
                    (() => {
                      const theme = themes.find(t => t?.setting?.isEmptyTheme === true);
                      const isActive = license[theme?.minLicenseType]?.order <= activeLicense?.order
                      return theme ? (
                        <div className={`w-[200px] relative `} style={{ aspectRatio: 200 / 265 }} key={theme?.id}>
                          <div
                            onClick={() => {
                              if (isDemo) return setIsIntegrationModalOpen(true)
                              setSelectedTheme(theme)

                            }}
                            className={` cursor-pointer relative border border-[#E3E8EF] rounded-[10px] h-full bg-[#F0EEFC] overflow-hidden w-full flex flex-col-reverse rounded-lg ${selectedTheme?.id == theme?.id
                              ? 'border-2 !border-[#7059ef]'
                              : 'border-2 border-[#E3E8EF] hover:border-[#A195E3]'
                              }`}
                          >
                            <FontAwesomeIcon
                              icon={faPlus}
                              className="text-[40px] duration-100 text-[#8A92A6] group-hover:text-[#7059EF]"
                              style={{
                                position: 'absolute',
                                left: '50%',
                                top: '40%',
                                transform: 'translate(-50%,-50%)',
                                margin: 0,
                              }}
                            />

                            <div className="px-3 flex items-center justify-between shrink-0 h-[50px] flex flex-row bg-[#F8F8F8]">
                              <p className="text-[15px] text-[#5E5873] font-semibold">{theme?.name || ''}</p>
                              <div></div>
                            </div>
                            {!isActive && <ThemeModalBadge type={"PREMIUM"} ></ThemeModalBadge>}
                          </div>

                        </div>
                      ) : null;
                    })()}
                </div>
              </div>
              <div
                className="flex-1 flex flex-col relative "
                style={{ padding: '25px 20px 0px 20px', gap: '20px', overflow: 'hidden' }}
              >
                <div className="absolute top-0 right-0 cursor-pointer p-4 z-[500]" onClick={() => setIsOpen(false)}>
                  <CloseButton className={'fill-[#60646F]'}></CloseButton>
                </div>
                <div className='scrollbar-y-visible rounded-xl overflow-auto pb-[20px]' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div className="text-[#5E5873]">Hazır Temalar</div>
                  <div>
                    <div className="flex flex-wrap gap-4">
                      {themes &&
                        themes
                          .filter(t => t?.minLicenseType !== 'WEBVIEW' && !t?.setting?.isEmptyTheme)
                          .sort((a, b) => {
                            return license[a?.minLicenseType]?.order - license[b?.minLicenseType]?.order
                          })
                          .map(theme => {
                            const isActive = license[theme?.minLicenseType]?.order <= activeLicense?.order


                            return (
                              <ThemeModalCardItem isActive={isActive} setIsIntegrationModalOpen={setIsIntegrationModalOpen} isDemo={isDemo} setSelectedTheme={setSelectedTheme} theme={theme} selectedTheme={selectedTheme} />
                            )
                          })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="height-[100px] border-1 border-[#E3E8EF] shrink-0"
              style={{
                borderBottomRightRadius: '10px',
                borderBottomLeftRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div className="w-[152px] pl-5"></div>
              <div className="flex flex-row  justify-center  gap-[25px] p-4 " style={{ alignItems: 'flex-end' }}>
                <div style={{ width: 232 }}>
                  <MyInput
                    isError={error}
                    isErrorMessage={'Tema adını giriniz.'}
                    labelViaPlaceholder={false}
                    type="text"
                    color="black"
                    onChange={e => setThemeName(e)}
                    placeholder="Tema Adı"
                    value={themeName}
                    classes={'w-[232px]'}
                  />
                </div>

              </div>
              <div className="pr-5" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div className="!h-[45px]">
                  <PrimaryButton
                    onClick={() => {
                      handleClickedSaveButton();
                    }}
                    value="Kaydet"
                    classes={'w-[232px] !h-[45px]'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isLicenseModalOpen && <ThemeLicenseModal licenseType={selectedTheme?.minLicenseType?.replace("_", " ")} setOpen={setIsLicenseModalOpen} />}
      {isIntegrationModalOpen && <ThemesIntegrationModal setOpen={setIsIntegrationModalOpen} />}
    </>
  );
}

export default ThemesModal;


const ThemeModalCardItem = ({ setIsIntegrationModalOpen, isActive, setSelectedTheme, isDemo, theme, selectedTheme }) => {

  const [isQrOpen, setIsQrOpen] = useState(false)
  return (
    <div className={`w-[200px] select-none relative`} style={{ aspectRatio: 200 / 265 }} key={theme?.id}>
      <div
        onClick={() => {
          if (isDemo) return setIsIntegrationModalOpen(true)
          setSelectedTheme(theme)

        }}
        className={`cursor-pointer border border-[#E3E8EF] rounded-[10px] h-full bg-[#F0EEFC] overflow-hidden w-full flex flex-col-reverse rounded-lg ${selectedTheme?.id == theme?.id
          ? 'border-2 !border-[#7059ef]'
          : `border-2 border-[#E3E8EF] hover:border-[#A195E3]`
          }`}
      >
        <div className="px-3 flex items-center justify-between shrink-0 h-[50px] flex flex-row bg-[#F8F8F8]">
          <p className="text-[15px] text-[#5E5873] font-semibold">{theme?.name || ''}</p>
          {theme?.previewUrl &&
            <div className='ml-auto border-[1.5px] rounded-[5px] border-gray-400 p-[1px]'
              style={{ borderColor: isQrOpen ? "#7059ef" : "black" }}
              onClick={(e) => {
                e.stopPropagation()
                setIsQrOpen(state => !state)
              }}>
              <QrCodeIcon color={isQrOpen ? "#7059ef" : "black"} width={25} height={25} />
            </div>
          }
        </div>
        <div className="flex-1 relative">
          {isQrOpen && theme?.previewUrl ?
            <div className='absolute left-0 top-0 bg-gray-200 flex items-center justify-center h-full flex flex-col gap-[10px]'>
              <QRCode
                size={256}
                style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                value={theme?.previewUrl}
                className="shrink-0"
                viewBox={`0 0 256 256`}
              ></QRCode>
              <p className='flex items-center text-[12px] px-[10px] text-center'>Önizleme için QR kodu okutunuz.</p>
            </div> :

            <img src={theme?.images} />

          }
        </div>
        {!isActive && <ThemeModalBadge type={theme.minLicenseType?.replace("NATIVE_", "")} ></ThemeModalBadge>}
      </div>

    </div>
  )
}

const badgeColors = {
  "BASIC": "#70C54B",
  "PRO": "#4D47CE",
  "PREMIUM": "#ff595a"
}
const ThemeModalBadge = ({ type }) => {

  const activeBadgeColor = badgeColors[type]
  return (
    <div className="absolute flex w-[100%] h-[100%] left-[0%] top-[0%] flex justify-center items-center text-white overflow-hidden " >
      <div className='absolute w-[140px] h-[40px] rotate-[-45deg] top-[16px] left-[-35px] flex items-center justify-center text-[13px] text-white text-center font-semibold' style={{ backgroundColor: activeBadgeColor }}>
        {translate(type)}
      </div>

    </div>
  )
}